import { createSlice } from "@reduxjs/toolkit";
import { getCategoryList } from "../../reduxApi/admin/CategoryReduxApi";

const categorySlice = createSlice({
    name: 'category',
    initialState: {
        status: 'idel',
        isFiltered: false,
        category: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteCategoryAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.category.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.category.splice(index, 1);
                }
            });
        },
        updateCategoryAction: (state, action) => {
            const index = state.category.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.category.splice(index, 1, action.payload);
            }
        },
        addCategoryAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.category.unshift(temp); 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getCategoryList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getCategoryList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.category = action.payload.data;
            })
    }
})
export const { deleteCategoryAction, updateCategoryAction, addCategoryAction, setFilteredStatus } = categorySlice.actions
export default categorySlice.reducer